import {Moment} from "moment";

export interface TariffsValues {
  current:TariffsCurrentValues;
  selected: TariffsSelectedValues
}

export interface TariffsCurrentValues {
  autoRenewal: boolean;
  limits: {
    students: number;
    storage: number;
  };
  used: {
    students: number;
    storage: number;
  };
  paidBy: Moment | null;
}

export interface TariffsSelectedValues {
  autoRenewal: boolean;
  paymentPeriod: PaymentPeriod;
  students: number;
  additionalStudents: AdditionalStudents;
  storage: number;
  prices: {
    students: number;
    storage: number;
    full: number;
  }
}

export enum PaymentPeriod {
  MonthEnd='month end',
  Month='month',
  ThreeMonth='three month',
  SixMonth='six month',
  Year='year',
}

export type AdditionalStudents = 2000 | 3000 | 4000 | 5000 | 'Unlimited' | null;